interface IServiceResponse<T = object> {
  result: Nullable<T>;
  success: boolean;
  errors: Error[];
}

abstract class ServiceResponseBase<T = object> implements IServiceResponse<T> {
  public result: Nullable<T> = null;
  public success: boolean = false;
  public errors: Error[] = [];

  public IsSuccessful(): boolean {
    return ((this.errors || []).length === 0 && this.success);
  }
}

export { IServiceResponse, ServiceResponseBase };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/service-request/response.ts